import styled from "styled-components";

export const StyledWrapper = styled.div`
  padding-top: 11px;
  padding-bottom: 5px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;

  .math-operations-title {
    padding-left: 17px;
    padding-right: 10px;
    margin-bottom: 4px;
    margin-left: -4px;
  }
`;
